export default __webpack_public_path__ + "static/media/LA-3.fbb27544.JPG";